<template>
  <div class="container">
    <section v-if="template.dbKey !== null">
      <h4 class="push-down-30 align-left head">PACKING LIST - {{ template.name }}</h4>
      <p class="push-down-20 align-left share-user">
        {{ createdBy }} has shared the following packing list with you!
      </p>
      <div class="packing-list-wrapper">
        <h5 class="align-left col-12 grid" v-if="template.packingListItems.length > 0">
          LIST OF ITEMS
        </h5>
        <h5 v-else>This list contains no items...</h5>
        <PackingList
          v-if="template.packingListItems.length > 0"
          readOnly="true"
          :items="template.packingListItems"
          :fullWidth="true"
          :showTitle="false"
        />
      </div>
      <div class="packing-list-wrapper">
        <h5 class="image-wrap" v-if="template.images.length === 0">
          This list contains no images...
        </h5>
        <RuxDetailsImages
          v-if="template.images.length > 0"
          readOnly="true"
          :currentRuxImages="template.images"
          :fullWidth="true"
          :showTitle="false"
        />
      </div>
       <div v-if="template.description" class="packing-list-wrapper description-head">
        <div class="col-12 grid">
         <p class="header">DESCRIPTION</p>
           <div class="description">{{ template.description }}</div>
          </div>
       </div>
    </section>
  </div>
</template>

<script>
import PackingList from './../PackingList'
import RuxDetailsImages from './../RuxDetailsImages'
export default {
  name: 'PackingListTemplatePublic',
  components: {
    PackingList,
    RuxDetailsImages,
  },
  computed: {
    template: function () {
      return this.$store.state.packingListTemplate.current
    },
    name: function () {
      return this.$store.state.packingListTemplate.current.name
    },
    createdBy: function () {
      return (
        this.$store.state.packingListTemplate.current.createdBy || 'Someone'
      )
    },
  },
  mounted() {
    this.$store.dispatch('packingListTemplate/getPublicPackingListTemplate', {
      uid: this.$route.params.uid,
      dbKey: this.$route.params.key,
    })
  },
}
</script>

<style lang='scss' scoped>
h5 {
  color: black;
  font-style: normal;
}
.head {
  font-family: "Neue Medium";
  margin-top: 40px;
}
.share-user {
  font-family: "Neue Roman";
}
.image-wrap {
  font-family: "Neue Roman";
  font-style: normal;
  font-size: 1.1rem;
}
.align-left {
  text-align: left;
}
.packing-list-wrapper {
  padding: 18px 4px;
  margin: 20px auto;
  background-color: white;
  border-radius: 0px;
  border: 1px solid black;
  box-shadow: 0 2px 2px rgb(0 0 0 / 11%), 0 1px 1px rgb(0 0 0 / 18%);
  @include respond-to('sm') {
    padding: 40px;
  }
}
.description-head {
  text-align: left;
  font-size: 1.25rem;
  .description {
  text-align: left;
  font-family: "Neue Roman";
  font-size: 1.1rem;
}
}
</style>